import Com from "components/styledComp/CommStyledComp";
import React from "react";

const SaaSArchitecture = () => {
  return (
    <Com.DivDetailSection>
      <Com.DivDetailHeading>
        <Com.DetailHeading>클라우드 아키텍처</Com.DetailHeading>
      </Com.DivDetailHeading>
      <div className="strategy-list">
        <div className="strategy">
          <Com.SpanStrategy>1</Com.SpanStrategy>
          <div className="strategy-title">
            <Com.StrongStrategy>멀티 테넌트 SaaS 구조</Com.StrongStrategy>
            <p className="strategy-desc">
              고객사(테넌트) 단위 데이터·권한·설정 분리<br />
              단일 서비스 플랫폼 기반 안전 운영 구조 설계
            </p>
          </div>
        </div>
        <div className="strategy">
          <Com.SpanStrategy>2</Com.SpanStrategy>
          <div className="strategy-title">
            <Com.StrongStrategy>확장성·유연성 중심 설계</Com.StrongStrategy>
            <p className="strategy-desc">
              사용량 증가에 따른 자원 확장 구조<br />
              서비스 중단 없이 업데이트·배포 가능한 클라우드 네이티브 구조
            </p>
          </div>
        </div>
        <div className="strategy">
          <Com.SpanStrategy>3</Com.SpanStrategy>
          <div className="strategy-title">
            <Com.StrongStrategy>웹·API 기반 연동</Com.StrongStrategy>
            <p className="strategy-desc">
              브라우저 기반 웹 관리 환경 제공 및 외부 시스템·단말기 API 연동 구조 구축
            </p>
          </div>
        </div>
      </div>
    </Com.DivDetailSection>
  );
};

export default SaaSArchitecture;
